var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logoSignIn && !_vm.loading)?_c('img',{staticClass:"signIn-logo",attrs:{"src":_vm.logoSignIn}}):_vm._e(),(!_vm.logoSignIn && !_vm.loading)?_c('img',{staticClass:"signIn-logo",attrs:{"alt":_vm.title,"src":"/the-one-stellenbosch/images/logo.svg"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }